/**
 * Prefix injected by the Symfony validation formatter (ExceptionHelper::formatValidationException)
 * ahead of each per-field violation, e.g. `Field "seats" error: Seat names must be unique`.
 * Stripped so only the human-readable reason is shown to the user.
 */
const FIELD_ERROR_PREFIX = /^Field "[^"]*" error: /;

const stripFieldPrefix = message => String(message).replace(FIELD_ERROR_PREFIX, '');

/**
 * Extract a human-readable error message from an API error response.
 * Tolerant to response shape: `error` (string | array) -> `errors` (array) -> `message` (string) -> fallback.
 */
export const extractApiError = (err, fallback) => {
	const data = err?.response?.data;
	const { error, errors, message } = data || {};

	if (Array.isArray(error) && error.length > 0) {
		return error.map(stripFieldPrefix).join(', ');
	}
	if (typeof error === 'string' && error) {
		return stripFieldPrefix(error);
	}
	if (Array.isArray(errors) && errors.length > 0) {
		return errors.map(stripFieldPrefix).join(', ');
	}
	if (typeof message === 'string' && message) {
		return message;
	}

	return fallback;
};
